import React from 'react';
import './CustomButton.css';

function RoundEdgeButton({ onClick, children, isDisabled = false, variant = 'roundEdge', className = '' }) {
    return (
        <button
            onClick={isDisabled ? null : onClick}
            className={isDisabled ? `custom-button-roundEdge-disabled` : `custom-button ${variant}  ${className}`}
            disabled={isDisabled}
        >
            {children}
        </button>
    );
};

export default RoundEdgeButton;